var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgGradient2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_299_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564 67.3359L607.904 379.302L900.674 327.271L635.038 468.046L772.076 747.855L564 522.892L355.924 747.855L492.962 468.046L227.326 327.271L520.096 379.302L564 67.3359Z",
    fill: "url(#paint0_linear_299_175)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter1_f_299_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.311 0L365.739 107.681V323.043L198.311 430.724L30.8838 323.043V107.681L198.311 0Z",
    fill: "#FCBC80",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter2_f_299_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.5 430.948L426.387 538.685V754.159L228.5 861.896L30.6132 754.159V538.685L228.5 430.948Z",
    fill: "#DC6146",
    fillOpacity: 0.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter3_f_299_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1086.23 0L1392.6 489.56H779.853L1086.23 0Z",
    fill: "#C08F87"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59,
    filter: "url(#filter4_f_299_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.772 371.253L1277.15 860.813H664.396L970.772 371.253Z",
    fill: "#C08F87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_299_175",
    x: -32.6741,
    y: -192.664,
    width: 1193.35,
    height: 1200.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    result: "effect1_foregroundBlur_299_175"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_299_175",
    x: -269.116,
    y: -300,
    width: 934.855,
    height: 1030.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_299_175"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_299_175",
    x: -269.387,
    y: 130.948,
    width: 995.773,
    height: 1030.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_299_175"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_299_175",
    x: 479.853,
    y: -300,
    width: 1212.75,
    height: 1089.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_299_175"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_299_175",
    x: 364.396,
    y: 71.2529,
    width: 1212.75,
    height: 1089.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_299_175"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_175",
    x1: 564,
    y1: 67.3359,
    x2: 564,
    y2: 819.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#872341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#872341",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGradient2);
export default __webpack_public_path__ + "static/media/bgGradient2.6dc5e530869d78c325dabb81970c96e6.svg";
export { ForwardRef as ReactComponent };